export default {
  title: 'Adicionar cartão',
  buttons: {
    save: 'Guardar',
  },
  feedback: {
    success: 'Cartão guardado com sucesso',
  },
};
